import { stringify } from "query-string";

class Service {
  static prepareFilters(filters) {
    return stringify(filters);
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/app/service.js